import React from 'react'
import colors from '../../../../../theme/colors'
import { ReactComponent as DeleteIcon } from '../../../../../assets/delete.svg'

export default ({
  arrayHelpers: {
    remove,
  },
  index,
}) => (
  <DeleteIcon onClick={() => remove(index)} style={styles.container} />
)

const styles = {
  container: {
    width: 'initial',
    height: '40px',
    padding: '2px 10px 0 0',
    fill: colors.darkGrey,
  },
}
